var StoreBuTypeEnum;
(function (StoreBuTypeEnum) {
    StoreBuTypeEnum["ecommerce"] = "E-commerce";
    StoreBuTypeEnum["store"] = "Store";
    StoreBuTypeEnum["office"] = "Office";
    StoreBuTypeEnum["smallStore"] = "Small Store";
    StoreBuTypeEnum["shop"] = "Shop";
})(StoreBuTypeEnum || (StoreBuTypeEnum = {}));
export default StoreBuTypeEnum;
//# sourceMappingURL=StoreBuTypeEnum.js.map